// extracted by mini-css-extract-plugin
export default {"html":"i0ZQXWl6CVT007POIjT2"};